import { useEffect, useState } from 'react'
import { QueryStatus, QueryStatusType } from 'src/types'
import {HttpCLG} from "../api/HttpCLG";
import {OperacionCLG} from "../types/types";

type UseOperacionResult<TOperacion> = {
    status: QueryStatusType
    operacion: TOperacion | undefined
}

export const useOperacionCLG: (idOperacion: number) => UseOperacionResult<OperacionCLG> = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionCLG>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpCLG.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return { status, operacion }
}
